import { type Notification, NotificationItem } from '@entities/notification';
import { NotificationPopover } from '@features/notification';

export interface NotificationListProps {
  items: Notification[];
  lastPage: boolean;
  loadingMore?: boolean;
  onLoadMore(): void;
  onSelect(item: Notification): void;
  /** "모두읽기". 없으면 버튼이 없다 */
  onReadAll?(): void;
  /** 읽지 않은 알림이 있는지 — 없으면 "모두읽기" 를 누를 수 없다 */
  hasUnread?: boolean;
}

/**
 * 알림 목록: NotificationPopover 에 NotificationItem 을 채운다.
 * 바닥까지 스크롤하면(마지막 쪽이 아니고 불러오는 중이 아니면) onLoadMore.
 */
export function NotificationList({
  items,
  lastPage,
  loadingMore = false,
  onLoadMore,
  onSelect,
  onReadAll,
  hasUnread = true,
}: NotificationListProps) {
  return (
    <div aria-busy={loadingMore || undefined} data-last-page={lastPage}>
      <NotificationPopover
        showLoading={!lastPage}
        onReadAll={onReadAll}
        canReadAll={hasUnread}
        onScrollEnd={() => {
          if (!lastPage && !loadingMore) onLoadMore();
        }}
      >
        {items.map((item) => (
          <div role="listitem" key={item.id}>
            <NotificationItem
              type={item.type}
              notifiedAt={item.notifiedAt}
              content={item.content}
              read={item.isRead}
              onSelect={() => onSelect(item)}
            />
          </div>
        ))}
      </NotificationPopover>
    </div>
  );
}
